const FACES_BAILLEUR_EXPORT_EXCEL = 'facesbailleur';

export default FACES_BAILLEUR_EXPORT_EXCEL;
